import {
  Close,
  Delete as DeleteIcon,
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
  Upload as UploadIcon,
  Visibility as VisibilityIcon,
} from "@mui/icons-material";
import DescriptionIcon from "@mui/icons-material/Description";
import ErrorIcon from "@mui/icons-material/Error";
import ReceiptIcon from "@mui/icons-material/Receipt";
import ViewStreamIcon from "@mui/icons-material/ViewStream";
import {
  Alert,
  AlertTitle,
  Avatar,
  Box,
  Button,
  Card,
  CardContent,
  Chip,
  Collapse,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Input,
  Typography,
} from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import { CustomButton } from "src/Components/Common/Button/CustomButton";
import LoadingIcon from "src/Components/Common/LoadingIcon";
import { DIALOG_MAX_WIDTHS } from "src/Components/Common/Modal/ModalWidth";
import useFetch from "src/Components/Common/useFetch";
import CustomToast from "src/Components/CustomToast";
import { API_ENDPOINTS } from "src/Utils/ApiConstants/ApiUrlConstants";
import { formatMoney, ToDineroObj } from "src/Utils/MoneyUtils";
import { uiLoggerNamesVendorPortal } from "src/Utils/Recon/UiLogger/Constants";
import { IssueCategorizationDescriptions, VendorResolutionStatus } from "./RejectedInvoicesVendorPortal";

const VendorPortalRejectedInvoicesResolveModal = ({
  openRejectedInvoicesResolveModal,
  setOpenRejectedInvoicesResolveModal,
  selectedRowForRejectedInvoicesResolveModal,
  rejectedInvoicesResolveModalTitle,
  listOpenVendorPortalInvoices,
  listCloseVendorPortalInvoices,
  handleUnauthorizedError,
  uiLogsVendorPortal,
}) => {
  const issueDetails = [
    {
      label: "GRN Date",
      value: selectedRowForRejectedInvoicesResolveModal?.grnDate
        ? moment(selectedRowForRejectedInvoicesResolveModal?.grnDate).format("DD/MM/YYYY")
        : "-",
    },
    { label: "GRN Number", value: selectedRowForRejectedInvoicesResolveModal?.grnNumber },
    {
      label: "GRN Amount",
      value: selectedRowForRejectedInvoicesResolveModal?.grnAmount
        ? formatMoney(ToDineroObj(selectedRowForRejectedInvoicesResolveModal.grnAmount))
        : "-",
    },
  ];

  const otherDetailsRows = [
    [
      { label: "Category", value: selectedRowForRejectedInvoicesResolveModal?.category },
      { label: "Outlet Name", value: selectedRowForRejectedInvoicesResolveModal?.outletName },
      { label: "City", value: selectedRowForRejectedInvoicesResolveModal?.city },
    ],
    [
      { label: "Invoice Number", value: selectedRowForRejectedInvoicesResolveModal?.invoiceNumber },

      { label: "PO Number", value: selectedRowForRejectedInvoicesResolveModal?.poNumber },
      { label: "Item Type", value: selectedRowForRejectedInvoicesResolveModal?.itemType },
    ],
    [{ label: "Dependency", value: selectedRowForRejectedInvoicesResolveModal?.dependency }],
  ];

  const [showDetails, setShowDetails] = useState(false);
  const [uploadedFiles, setUploadedFiles] = useState([]);

  const [attachments, setAttachments] = useState([]);
  const [fileInput, setFileInput] = useState<HTMLInputElement | null>(null);
  const [isLoadingSubmit, setIsLoadingSubmit] = useState(false);
  const token = localStorage.getItem("vendorPortalToken");

  useEffect(() => {
    listAttachments();
  }, []);

  const listAttachments = () => {
    useFetch(
      API_ENDPOINTS.LIST_INVOICE_ATTACHMENTS_VP(selectedRowForRejectedInvoicesResolveModal?.grnNumber).url,
      "GET",
      {
        failureMessage: API_ENDPOINTS.LIST_INVOICE_ATTACHMENTS_VP(selectedRowForRejectedInvoicesResolveModal?.grnNumber)
          .failureMessage,
        config: {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
        thenCallBack: (response) => {
          setAttachments(response.data?.attachments || []);
        },
        catchCallBack: (error) => {
          handleUnauthorizedError(error);
        },
      }
    );
  };

  const handleFileUpload = (event) => {
    const selectedFiles = Array.from(event.target.files);
    const totalFiles = uploadedFiles.length + selectedFiles.length;

    if (totalFiles > 5) {
      toast.error(<CustomToast message="You can only upload up to 5 files." />);
      event.target.value = ""; // Clear input so same files can be re-selected
      return;
    }

    setUploadedFiles((prev) => [...selectedFiles, ...prev]);
    event.target.value = "";
    uiLogsVendorPortal(uiLoggerNamesVendorPortal.UI_SST_IR_VENDOR_TAKEACTION_UPLOAD_CLICK.message, {
      function: uiLoggerNamesVendorPortal.UI_SST_IR_VENDOR_TAKEACTION_UPLOAD_CLICK.functionName,
      vendorCode: selectedRowForRejectedInvoicesResolveModal?.vendorCode,
      grnNumber: selectedRowForRejectedInvoicesResolveModal?.grnNumber,
      grnStatus: selectedRowForRejectedInvoicesResolveModal?.issueStatus,
      vendorName: selectedRowForRejectedInvoicesResolveModal?.vendorName,
    });
  };

  const handleView = (file) => {
    const fileURL = URL.createObjectURL(file);
    window.open(fileURL, "_blank");
    uiLogsVendorPortal(uiLoggerNamesVendorPortal.UI_SST_IR_VENDOR_TAKEACTION_VIEWATTACHMENT_CLICK.message, {
      function: uiLoggerNamesVendorPortal.UI_SST_IR_VENDOR_TAKEACTION_VIEWATTACHMENT_CLICK.functionName,
      vendorCode: selectedRowForRejectedInvoicesResolveModal?.vendorCode,
      grnNumber: selectedRowForRejectedInvoicesResolveModal?.grnNumber,
      grnStatus: selectedRowForRejectedInvoicesResolveModal?.issueStatus,
      vendorName: selectedRowForRejectedInvoicesResolveModal?.vendorName,
    });
  };

  const handleDelete = (index) => {
    setUploadedFiles((prev) => prev.filter((_, i) => i !== index));
    uiLogsVendorPortal(uiLoggerNamesVendorPortal.UI_SST_IR_VENDOR_TAKEACTION_DELETEATTACHMENT_CLICK.message, {
      function: uiLoggerNamesVendorPortal.UI_SST_IR_VENDOR_TAKEACTION_DELETEATTACHMENT_CLICK.functionName,
      vendorCode: selectedRowForRejectedInvoicesResolveModal?.vendorCode,
      grnNumber: selectedRowForRejectedInvoicesResolveModal?.grnNumber,
      grnStatus: selectedRowForRejectedInvoicesResolveModal?.issueStatus,
      vendorName: selectedRowForRejectedInvoicesResolveModal?.vendorName,
    });
  };

  const handleClose = () => {
    setOpenRejectedInvoicesResolveModal(false);
  };

  const isActionAllowedForStatus = (status: string): boolean => {
    const allowedStatuses = [
      VendorResolutionStatus.Unassigned,
      VendorResolutionStatus.InProgress,
      VendorResolutionStatus.PendingApproval,
      VendorResolutionStatus.RejectedAgain,
    ];
    return allowedStatuses.includes(status);
  };

  const handleSubmit = () => {
    setIsLoadingSubmit(true);
    const bodyFormData = new FormData();

    for (const item of uploadedFiles) {
      bodyFormData.append("files", item);
    }

    useFetch(
      API_ENDPOINTS.LIST_INVOICE_ATTACHMENTS_VP(selectedRowForRejectedInvoicesResolveModal?.grnNumber).url,
      "POST",
      {
        failureMessage: API_ENDPOINTS.LIST_INVOICE_ATTACHMENTS_VP(selectedRowForRejectedInvoicesResolveModal?.grnNumber)
          .failureMessage,
        config: {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "multipart/form-data",
          },
        },
        data: bodyFormData,
        showSuccessToast: true,
        thenCallBack: () => {
          listOpenVendorPortalInvoices(token);
          listCloseVendorPortalInvoices(token);
          handleClose();
          setUploadedFiles([]);
          setIsLoadingSubmit(false);
          uiLogsVendorPortal(uiLoggerNamesVendorPortal.UI_SST_IR_VENDOR_TAKEACTION_SUBMIT_CLICK.message, {
            function: uiLoggerNamesVendorPortal.UI_SST_IR_VENDOR_TAKEACTION_SUBMIT_CLICK.functionName,
            vendorCode: selectedRowForRejectedInvoicesResolveModal?.vendorCode,
            grnNumber: selectedRowForRejectedInvoicesResolveModal?.grnNumber,
            grnStatus: selectedRowForRejectedInvoicesResolveModal?.issueStatus,
            vendorName: selectedRowForRejectedInvoicesResolveModal?.vendorName,
          });
        },
        catchCallBack: (error) => {
          setIsLoadingSubmit(false);
          handleUnauthorizedError(error);
        },
      }
    );
  };

  const handleViewAttachment = (file) => {
    useFetch(
      API_ENDPOINTS.VIEW_INVOICE_ATTACHMENT_VP(selectedRowForRejectedInvoicesResolveModal?.grnNumber).url,
      "POST",
      {
        failureMessage: API_ENDPOINTS.VIEW_INVOICE_ATTACHMENT_VP(selectedRowForRejectedInvoicesResolveModal?.grnNumber)
          .failureMessage,
        config: {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
        data: {
          attachmentLink: file.fileKey,
        },
        thenCallBack: (_res) => {
          const link = document.createElement("a");
          link.href = _res.data.attachment;
          link.download = file.fileName;
          link.target = "_blank";
          link.referrerPolicy = "no-referrer";
          link.style.display = "none";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          uiLogsVendorPortal(uiLoggerNamesVendorPortal.UI_SST_IR_VENDOR_TAKEACTION_VIEWATTACHMENT_CLICK.message, {
            function: uiLoggerNamesVendorPortal.UI_SST_IR_VENDOR_TAKEACTION_VIEWATTACHMENT_CLICK.functionName,
            vendorCode: selectedRowForRejectedInvoicesResolveModal?.vendorCode,
            grnNumber: selectedRowForRejectedInvoicesResolveModal?.grnNumber,
            grnStatus: selectedRowForRejectedInvoicesResolveModal?.issueStatus,
            vendorName: selectedRowForRejectedInvoicesResolveModal?.vendorName,
          });
          // window.open(_res.data.signedUrl, "_blank", "noopener,noreferrer");
        },
        catchCallBack: (error) => {
          handleUnauthorizedError(error);
        },
      }
    );
  };

  return (
    <Dialog open={openRejectedInvoicesResolveModal} maxWidth={DIALOG_MAX_WIDTHS.SM} fullWidth>
      <DialogTitle className="dialog-title">
        <div className="heading-m">{rejectedInvoicesResolveModalTitle}</div>
        <div className="vertical_center_align">
          <IconButton onClick={handleClose}>
            <Close />
          </IconButton>
        </div>
      </DialogTitle>

      <DialogContent dividers sx={{ p: 2 }}>
        <Alert
          severity="warning"
          sx={{
            backgroundColor: "#fff4e5",
            marginBottom: 2,
          }}
        >
          <AlertTitle sx={{ fontWeight: 500 }}>
            {selectedRowForRejectedInvoicesResolveModal.issueCategory || ""}
          </AlertTitle>
          {IssueCategorizationDescriptions[selectedRowForRejectedInvoicesResolveModal.issueCategory] || ""}
        </Alert>

        <Card sx={{ marginBottom: 2, border: "1px solid #d6d6d6" }}>
          <CardContent sx={{ padding: "16px 24px" }}>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <Box>
                <Typography className="heading-xs">
                  {isActionAllowedForStatus(selectedRowForRejectedInvoicesResolveModal.issueStatus)
                    ? "Upload Invoice Copy"
                    : "Invoice Copy"}
                </Typography>
                {isActionAllowedForStatus(selectedRowForRejectedInvoicesResolveModal.issueStatus) && (
                  <Typography className="body-s-medium" color="textSecondary">
                    Attach your invoice file here (supported formats PDF, JPG, PNG).
                  </Typography>
                )}
              </Box>
              {isActionAllowedForStatus(selectedRowForRejectedInvoicesResolveModal.issueStatus) && (
                <>
                  <Input
                    type="file"
                    inputRef={(ref) => setFileInput(ref)}
                    sx={{ display: "none" }}
                    onChange={handleFileUpload}
                    inputProps={{
                      accept: ".pdf,.jpg,.png",
                      multiple: true,
                    }}
                  />
                  <CustomButton
                    size="small"
                    colorToken="violet"
                    variant="outlined"
                    startIcon={<UploadIcon />}
                    onClick={() => fileInput?.click()}
                    disabled={uploadedFiles.length >= 5}
                  >
                    Upload
                  </CustomButton>
                </>
              )}
            </Box>
          </CardContent>

          {uploadedFiles.map((file, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                padding: "8px 24px",
                backgroundColor: "#f2f2f2",
                borderTop: "1px solid #d6d6d6",
              }}
            >
              <Chip
                avatar={
                  <Avatar sx={{ backgroundColor: "#541c4c", color: "white" }}>
                    <DescriptionIcon sx={{ fontSize: 14, color: "white" }} />
                  </Avatar>
                }
                label={
                  <Box
                    title={file.name}
                    sx={{
                      maxWidth: "250px",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      whiteSpace: "nowrap",
                    }}
                  >
                    {file.name}
                  </Box>
                }
                variant="outlined"
                sx={{
                  maxWidth: "250px",
                  borderColor: "#541c4c",
                  color: "#541c4c",
                  flex: 1, // Allow the chip to take available space
                }}
              />
              <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
                <CustomButton
                  size="small"
                  colorToken="violet"
                  variant="outlined"
                  startIcon={<VisibilityIcon />}
                  onClick={() => handleView(file)}
                >
                  View
                </CustomButton>
                {isActionAllowedForStatus(selectedRowForRejectedInvoicesResolveModal.issueStatus) && (
                  <CustomButton
                    size="small"
                    color="error"
                    variant="outlined"
                    startIcon={<DeleteIcon />}
                    onClick={() => handleDelete(index)}
                  >
                    Delete
                  </CustomButton>
                )}
              </Box>
            </Box>
          ))}
          {attachments?.length > 0 &&
            attachments?.map((file, index) => (
              <Box
                key={index}
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  padding: "8px 24px",
                  backgroundColor: "#f2f2f2",
                  borderTop: "1px solid #d6d6d6",
                }}
              >
                <Chip
                  avatar={
                    <Avatar sx={{ backgroundColor: "#541c4c", color: "white" }}>
                      <DescriptionIcon sx={{ fontSize: 14, color: "white" }} />
                    </Avatar>
                  }
                  label={
                    <Box
                      title={file.fileName}
                      sx={{
                        maxWidth: "250px",
                        overflow: "hidden",
                        textOverflow: "ellipsis",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {file.fileName}
                    </Box>
                  }
                  variant="outlined"
                  sx={{
                    maxWidth: "250px",
                    borderColor: "#541c4c",
                    color: "#541c4c",
                    flex: 1, // Allow the chip to take available space
                  }}
                />
                <Box sx={{ display: "flex", gap: 1, flexShrink: 0 }}>
                  <CustomButton
                    size="small"
                    colorToken="violet"
                    variant="outlined"
                    startIcon={<VisibilityIcon />}
                    onClick={() => handleViewAttachment(file)}
                  >
                    View
                  </CustomButton>
                </Box>
              </Box>
            ))}
        </Card>

        <Card sx={{ backgroundColor: "#fafafa" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              padding: "8px 16px",
              alignItems: "center",
            }}
          >
            <Box
              className="heading-xs"
              sx={{ display: "flex", alignItems: "center", gap: 1, color: "rgba(0, 0, 0, 0.60)" }}
            >
              <ErrorIcon />
              <Typography className="heading-xs">Status</Typography>
            </Box>
            <Chip
              label={selectedRowForRejectedInvoicesResolveModal.issueStatus} // Dynamically set the label
              variant="outlined"
              color={
                selectedRowForRejectedInvoicesResolveModal.issueStatus === VendorResolutionStatus.InProgress
                  ? "primary"
                  : selectedRowForRejectedInvoicesResolveModal.issueStatus === VendorResolutionStatus.PendingApproval
                  ? "warning"
                  : selectedRowForRejectedInvoicesResolveModal.issueStatus === VendorResolutionStatus.InvoiceProcessing
                  ? "success"
                  : selectedRowForRejectedInvoicesResolveModal.issueStatus === VendorResolutionStatus.Posted
                  ? "success"
                  : "default" // Default color if no match
              }
            />
          </Box>

          <Box sx={{ padding: "16px" }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                marginBottom: 2,
              }}
            >
              <Box
                className="heading-xs"
                sx={{ display: "flex", alignItems: "center", gap: 1, color: "rgba(0, 0, 0, 0.60)" }}
              >
                <ReceiptIcon />
                <Typography className="heading-xs">Issue Details</Typography>
              </Box>
              <Button
                endIcon={showDetails ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                sx={{ color: "#0288d1" }}
                onClick={() => setShowDetails(!showDetails)}
              >
                {showDetails ? "Less Info" : "More Info"}
              </Button>
            </Box>

            <Box sx={{ display: "flex", gap: 2, marginBottom: 3 }}>
              {issueDetails.map((detail, index) => (
                <Box
                  key={index}
                  sx={{
                    flex: 1,
                    padding: "8px 12px",
                    border: "1px solid rgba(0, 0, 0, 0.12)",
                    borderRadius: 1,
                  }}
                >
                  <Typography className="body-s-bold">{detail.label}</Typography>
                  <Typography className="body-s-medium">{detail.value}</Typography>
                </Box>
              ))}
            </Box>
            <Collapse in={showDetails}>
              <Box
                className="heading-xs"
                sx={{
                  display: "flex",
                  alignItems: "center",
                  gap: 1,
                  marginBottom: 2,
                  color: "rgba(0, 0, 0, 0.60)",
                }}
              >
                <ViewStreamIcon />
                <Typography className="heading-xs">Other Details</Typography>
              </Box>

              {otherDetailsRows.map((row, rowIndex) => (
                <Box key={rowIndex} sx={{ display: "flex", gap: 2, marginBottom: 2 }}>
                  {row.map((detail, colIndex) => (
                    <Box
                      key={colIndex}
                      sx={{
                        flex: 1,
                        padding: "8px 12px",
                        border: "1px solid rgba(0, 0, 0, 0.12)",
                        borderRadius: 1,
                      }}
                    >
                      <Typography className="body-s-bold">{detail.label}</Typography>
                      <Typography className="body-s-medium">{detail.value}</Typography>
                    </Box>
                  ))}
                </Box>
              ))}
            </Collapse>
          </Box>
        </Card>
      </DialogContent>

      {isActionAllowedForStatus(selectedRowForRejectedInvoicesResolveModal.issueStatus) && (
        <DialogActions className="dialog-actions">
          <CustomButton size="medium" colorToken="violet" variant="text" onClick={handleClose}>
            Cancel
          </CustomButton>
          <CustomButton
            size="medium"
            colorToken="violet"
            variant="contained"
            disabled={uploadedFiles?.length === 0 || isLoadingSubmit}
            startIcon={<LoadingIcon loading={isLoadingSubmit} />}
            onClick={() => {
              handleSubmit();
            }}
          >
            Submit
          </CustomButton>
        </DialogActions>
      )}
    </Dialog>
  );
};

export default VendorPortalRejectedInvoicesResolveModal;
